module.exports = __webpack_public_path__ + "img/vp.f8407731.png";